export default __webpack_public_path__ + "static/media/logo192.bf37cdbc.png";